import { Controller } from "@hotwired/stimulus"

// GOAT SPAM Protector — the staff View Numbers modal body (#17148).
//
// An agent's number cards are served into a React modal (FormModal + a Turbo
// Frame). Each card carries its own Bootstrap dialogs (Clean My Number, Check
// Attestation). Left inside the React dialog they would open in its stacking
// context, BELOW the backdrop Bootstrap appends to <body>, and could not be
// used. So while the frame is open its dialogs are moved to <body> — exactly
// where they sit on the page — and removed again when the frame goes away.
//
// Escape inside a lifted dialog closes that dialog only: the React modal
// listens for Escape on the document, so the key stops at the dialog.
export default class extends Controller {
  connect() {
    this.lifted = Array.from(this.element.querySelectorAll(".modal"))
    this.lifted.forEach((dialog) => {
      dialog.addEventListener("keydown", this.keepEscapeInside)
      document.body.appendChild(dialog)
    })
  }

  // A dialog still open when the frame goes away (the React modal closed by
  // navigation, say) is hidden first and removed on hidden.bs.modal, so
  // Bootstrap clears its backdrop and the body scroll lock; dispose() alone
  // would strand both.
  disconnect() {
    (this.lifted || []).forEach((dialog) => {
      dialog.removeEventListener("keydown", this.keepEscapeInside)
      const instance = window.bootstrap?.Modal?.getInstance(dialog)
      if (instance && dialog.classList.contains("show")) {
        dialog.addEventListener("hidden.bs.modal", () => {
          instance.dispose()
          dialog.remove()
        }, { once: true })
        instance.hide()
      } else {
        instance?.dispose()
        dialog.remove()
      }
    })
    this.lifted = []
  }

  keepEscapeInside = (event) => {
    if (event.key === "Escape") event.stopPropagation()
  }
}
